export default __webpack_public_path__ + "static/media/exploded-view_sprite.9037b2cc.png";